module.exports = __webpack_public_path__ + "6bc2c17/img/whatsapp.2a9095f3.svg";